import Page from '../components/Page'
import Section from '../components/Section'
import Paragraphs from '../components/Paragraphs'
import PrimaryButton from '../components/PrimaryButton'
import PrimaryTitle from '../components/PrimaryTitle'
import VRScene from '../components/VRScene'
import ProjectNeomentoCard from '../components/ProjectNeomentoCard'
import Support from '../components/Support'
import TinyLink from '../components/TinyLink'
import LargeCard from '../components/LargeCard'
import paths from '../path'


const pageTitle = 'Ängste behandeln mit VR-Therapie'

const contactItem = { title: 'Kontakt', path: paths.contact }

const hero = {
  titles: [
    'Erweitern Sie Ihr Therapiezimmer.',
    'Einfach und jederzeit.',
  ],
}

const concept = {
  title: 'Das Konzept',
  paragraphs: [
    'Virtual-Reality-Therapie ermöglicht es, in wenigen Sekunden ein Büro oder einen Gruppenraum in eine therapeutisch relevante Umgebung zu verwandeln. Eine praxisfreundliche Art der in vivo Therapie wird verfügbar: Die in virtuo oder VR-Therapie (VR-T).',
    'PatientInnen können vor Ihren Augen in die U-Bahn steigen, einen Vortrag vor Publikum halten und viele weitere Situationen direkt im Therapiezimmer erleben. Auf Knopfdruck wird über den VR-PC ein virtueller Raum generiert. Die virtuellen Szenen können vorab bedarfsgerecht zusammengestellt werden. Während der Sitzung geben Ihnen zahlreiche Einstellungen größtmögliche Kontrolle über den Ablauf.',
    'Eine effektive VR-Therapie sollte gemeinsam mit Therapierenden stattfinden. Ziel soll es nicht sein, TherapeutInnen zu ersetzen.Vielmehr stellen wir ein möglichst effektives Tool zur einfachen und effektiven Umsetzung von Expositionen, Trainings und therapeutisch wirksamer Erlebnisse zur Verfügung.',
  ],
  cta: 'Mehr zu den Inhalten neomentos >',
  ctaHref: paths.product
}

const openDoors = {
  title:
    'VR-T ermöglicht es PatientInnen, Wege zu gehen und Türen zu öffnen, die zuvor verschlossen waren.',
}

const therapy = {
  title: 'neomento VR-Therapie',
  paragraphs: [
    'Wir wollen die Umsetzbarkeit hochwertiger in vivo Therapien vereinfachen und somit Therapeuten und Patienten beim Erreichen der Therapieziele effektiv unterstützen. PatientInnen sollen in VR positive Erfahrungen machen, Situationen üben, neue Konzepte lernen und sich mit Problemen und Ängsten auseinandersetzen können. VR-T stärkt zudem den Alltagstransfer. Mit neomento wollen wir TherapeutInnen dazu befähigen, Ihren PatientInnen Lebensqualität und Autonomie zurückzugeben.',
    'Auch wenn Effektivität und Nützlichkeit von VR-T erwiesen sind, braucht die Integration in die Versorgung Aufklärung und Unterstützung. Daher helfen wir Ihnen bei allen Fragen zum Thema VR-Therapie und assistieren bei der Implementierung des Systems.',
  ],
  cta: 'VR-T Einsatzbereiche >',
  ctaHref: paths.product
}

const treatment = {
  title: 'VR-Therapie erleichtert Expositionstherapie. Zugleich eröffnen sich neue Möglichkeiten.',
  description:
    '',
  cta: 'Termin vereinbaren und mehr erfahren',
  ctaHref: paths.contact,
  imgSrc: '/vrBox.svg',
  imgAlt: 'vr',
}

const setup = {
  title: 'Das Setup',
  paragraphs: [
    'Neben der Therapiesoftware erhalten Sie ein komplettes VR-System, das eine VR-Brille sowie einen Therapeuten-PC umfasst. Die Anforderungen an einen VR-T-Raum sind überschaubar und beschränken sich auf ein Bewegungsfläche von ca. 5m² sowie einen Arbeitsplatz für die TherapeutInnen. Der Raum kann weiterhin als Gesprächs- oder Gruppenraum genutzt werden.',
  ],
}

const session = {
  title: 'Skizze einer VR-T Sitzung',
  steps: [
    { title: 'Schritt 1', description: 'Szenario wählen und anpassen' },
    { title: 'Schritt 2', description: 'VR-T Sitzung starten' },
    { title: 'Schritt 3', description: 'Exposition steuern' },
    { title: 'Schritt 4', description: 'Sitzung auswerten und besprechen' },
  ],
}

const evidenceBased = {
  title: 'Evidenzbasierte VR-Therapie: neomento',
  paragraphs: [
    'Die im Rahmen des VR-Therapie-Projektes neomento entwickelte Software ist eine klinisch und technologisch akkurate Umsetzung evidenzbasierter Virtual-Reality-Therapie. Wissenschaftliche Evidenzen, Erfahrungen und Konzepte angewandter Psychotherapie, sowie Vorgaben moderner Softwareentwicklung haben eine besonders anspruchsvolle Interpretation des Begriffs VR-Therapie hervorgebracht.',
  ],
}

const virtualReality = {
  title: 'Virtual Reality',
  paragraphs: [
    'Zentrales Element stellen die zwei Displays der VR-Brille dar, die das sogenannte binokulare Sehen nachahmen. Ein virtueller Raum wird um den Nutzer herum generiert und zugleich dessen Räumlichkeit simuliert. Über integrierte Kopfhörer wird der zur jeweiligen Umwelt passende Sound präsentiert, um das Eintauchen in die virtuelle Welt noch weiter zu verstärken.',
    'VR-Technologie und ihr Nutzen für die Psychotherapie sind seit Jahrzehnten bekannt. Die Möglichkeit, einen Menschen in eine kontrollierbare, als wirklich empfundene Realität eintauchen zu lassen, birgt enormes therapeutisches Potential. Das Besondere ist dabei die Idee, den Nutzer zum Protagonisten zu machen und dadurch ein persönliches Erleben und Wahrnehmen zu ermöglichen - Verhalten, Emotionen und Denken des Nutzers passen sich vollständig an die virtuelle Erfahrung an. Das Gesehene wird nicht mehr nur passiv wahrgenommen, sondern aktiv erlebt.',
  ],
}

const BackgroundSection = <Section>
  <div>
    {hero.titles.map((title, index) => (
      <div className={`${index > 0 ? '-mt-4' : ''}`} key={index}>
        <PrimaryTitle mainColor title={title} />
      </div>
    ))}
  </div>
  <PrimaryButton title={contactItem.title} href={contactItem.path} />
</Section>

export default function Therapy() {
  return (
    <Page title={pageTitle} background="deskSetupHero.png" backgroundSmall="deskSetupHeroHalf.png" backgroundSection={BackgroundSection}>
      <Section partialWidth>
        <div>
          <PrimaryTitle title={concept.title} />
          <Paragraphs paragraphs={concept.paragraphs} />
          <div className="pt-8">
            <TinyLink href={concept.ctaHref}>{concept.cta}</TinyLink>
          </div>
        </div>
      </Section>
      <Section dark partialWidth>
        <PrimaryTitle title={openDoors.title} hero />
      </Section>
      <Section partialWidth>
        <div>
          <PrimaryTitle title={therapy.title} />
          <Paragraphs paragraphs={therapy.paragraphs} />
          <div className="pt-8">
            <TinyLink href={therapy.ctaHref}>{therapy.cta}</TinyLink>
          </div>
        </div>
      </Section>
      <Section>
        <LargeCard
          title={treatment.title}
          description={treatment.description}
          cta={treatment.cta}
          ctaHref={treatment.ctaHref}
          imgSrc={treatment.imgSrc}
          imgAlt={treatment.imgAlt}
        />
      </Section>
      <Section>
        <PrimaryTitle title={setup.title} />
        <Paragraphs paragraphs={setup.paragraphs} />
      </Section>
      <img className="w-full" src="/headsetOnDeskHero.png" alt="" />
      <Section>
        <PrimaryTitle center title={session.title} />
        <div className="relative border-t-2 pt-8 ">
          <div className="text-4xl leading-9 -mt-5 absolute right-0 top-0">
            {'>'}
          </div>
          <div className="grid sm:grid-cols-4 grid-cols-2 gap-4">
            {session.steps.map((session, index) => (
              <div className="bg-lightGray rounded-3xl md:px-8 md:py-8 sm:px-4 sm:py-4 py-6 px-6" key={index}>
                <div className="text-grayDarkLight font-bold lg:text-base text-sm">
                  {session.title}
                </div>
                <div className="lg:text-2xl text-sm font-bold lg:mt-6 mt-4">
                  {session.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>
      <Section>
        <PrimaryTitle title={evidenceBased.title} />
        <Paragraphs paragraphs={evidenceBased.paragraphs} />
      </Section>
      <Section dark>
        <div className="flex flex-col sm:flex-row sm:space-x-20">
          <div className="w-full sm:w-1/3 md:w-2/4 sm:text-right">
            <PrimaryTitle hero title={virtualReality.title} />
          </div>
          <div className="w-full sm:w-2/3 md:w-2/4">
            <Paragraphs paragraphs={virtualReality.paragraphs} />
          </div>
        </div>
      </Section>
      <VRScene />
      <Section>
        <ProjectNeomentoCard />
      </Section>
      <Section>
        <Support />
      </Section>
    </Page >
  )
}
